import { type Node } from '@xyflow/react';

import {
  type AppNode,
  type CanvasModeType,
  type ImageData,
  type ImageTransformMode,
  type TextData,
  type VideoData,
  type VideoTransformMode,
} from '../types';

const VIDEO_TRANSFORM_MODES = new Set<string>(['videoExtend'] satisfies VideoTransformMode[]);

export const isVideoTransformMode = (mode: CanvasModeType): mode is VideoTransformMode =>
  VIDEO_TRANSFORM_MODES.has(mode);

export const isImageTransformMode = (mode: CanvasModeType): mode is ImageTransformMode =>
  mode !== 'default' && !isVideoTransformMode(mode);

export type ImageNode = Node<ImageData, 'image'>;

export const isImageNode = (obj: AppNode | undefined): obj is ImageNode => obj?.type === 'image';

export type TextNode = Node<TextData, 'text'>;

export const isTextNode = (obj: AppNode | undefined): obj is TextNode => obj?.type === 'text';

export type VideoNode = Node<VideoData, 'video'>;

export const isVideoNode = (obj: AppNode | undefined): obj is VideoNode => obj?.type === 'video';
